import Vue from 'vue';
import VueRouter from 'vue-router';
import Admin from '../views/Admin.vue';
import Customers from '../views/Customers.vue';
import ApiPolicy from '../views/ApiPolicy.vue';
import Domain from '../views/Domain.vue';
import Layers from '../views/Layers.vue';
import PolicyDetails from '../views/PolicyDetails.vue';
import TimeseriesConfig from '../views/TimeseriesConfig.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Admin',
    component: Admin
  },
  {
    path: '/customers',
    name: 'Customers',
    component: Customers
  },
  {
    path: '/api-policy',
    name: 'ApiPolicy',
    component: ApiPolicy
  },
  {
    path: '/policy-details/new',
    name: 'PolicyDetailsNew',
    component: PolicyDetails
  },
  {
    path: '/policy-details/:policy_id',
    name: 'PolicyDetails',
    component: PolicyDetails
  },
  {
    path: '/domain',
    name: 'Domain',
    component: Domain
  },
  {
    path: '/layers',
    name: 'Layers',
    component: Layers
  },
  {
    path: '/statistics',
    name: 'Statistics',
    component: () => import('../views/Statistics.vue')
  },
  {
    path: '/timeseries-config',
    name: 'TimeseriesConfig',
    component: TimeseriesConfig
  }
];

const router = new VueRouter({
  routes
});

export default router;
